import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './components/auth/AuthProvider';
import { IntercomProvider } from './components/IntercomProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Initialize Sentry BEFORE React renders
import { initSentry } from './lib/sentry';
initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}
console.log("[DEBUG] Found root element, mounting App...");

import ErrorBoundary from './components/ErrorBoundary';

// Always use BrowserRouter for clean URLs (hash routing removed for Google Ads + sitelinks)
// Production rewrites are handled by vercel.json

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <IntercomProvider>
              <App />
            </IntercomProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);
